import { render, staticRenderFns } from "./SingleSelectItem.vue?vue&type=template&id=fb4bbee0&"
import script from "./SingleSelectItem.vue?vue&type=script&lang=ts&"
export * from "./SingleSelectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports